import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { useShareActions } from '../../hooks/use-share-action'
import { useEngineStore } from '../../stores/use-engine-store'
import { SharePreviewDialog } from './share-preview-dialog'

export function ShareSelectionBar() {
  const isShareMode = useEngineStore((s) => s.shareMode.isShareMode)
  const { selectedCount, exitShareMode, canShare } = useShareActions()
  const [previewOpen, setPreviewOpen] = useState(false)
  if (!isShareMode) return null
  return (
    <>
      <div className='bg-background/95 fixed right-0 bottom-0 left-0 z-30 border-t backdrop-blur'>
        <div className='mx-auto flex max-w-4xl items-center justify-between px-4 py-3'>
          <Button variant='ghost' onClick={exitShareMode}>
            取消
          </Button>
          <span className='text-muted-foreground text-sm'>
            已选择 {selectedCount}/10 条消息
          </span>
          <Button disabled={!canShare} onClick={() => setPreviewOpen(true)}>
            生成分享图
          </Button>
        </div>
      </div>

      <SharePreviewDialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  )
}
